/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
    TagReference,
    TagReferenceFromJSON,
    TagReferenceFromJSONTyped,
    TagReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface CommentUpdate
 */
export interface CommentUpdate {
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof CommentUpdate
     */
    assignee?: ElementsUserMiniReference;
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof CommentUpdate
     */
    user?: ElementsUserMiniReference;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof CommentUpdate
     */
    drawing?: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {Array<TagReference>}
     * @memberof CommentUpdate
     */
    tags?: Array<TagReference>;
    /**
     * 
     * @type {string}
     * @memberof CommentUpdate
     */
    text?: string;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdate
     */
    time?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof CommentUpdate
     */
    isCloud?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CommentUpdate
     */
    resolved?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof CommentUpdate
     */
    resolvedDate?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdate
     */
    asset: number;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdate
     */
    root?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CommentUpdate
     */
    parent?: number | null;
}

export function CommentUpdateFromJSON(json: any): CommentUpdate {
    return CommentUpdateFromJSONTyped(json, false);
}

export function CommentUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CommentUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assignee': !exists(json, 'assignee') ? undefined : ElementsUserMiniReferenceFromJSON(json['assignee']),
        'user': !exists(json, 'user') ? undefined : ElementsUserMiniReferenceFromJSON(json['user']),
        'drawing': !exists(json, 'drawing') ? undefined : json['drawing'],
        'tags': !exists(json, 'tags') ? undefined : ((json['tags'] as Array<any>).map(TagReferenceFromJSON)),
        'text': !exists(json, 'text') ? undefined : json['text'],
        'time': !exists(json, 'time') ? undefined : json['time'],
        'isCloud': !exists(json, 'is_cloud') ? undefined : json['is_cloud'],
        'resolved': !exists(json, 'resolved') ? undefined : json['resolved'],
        'resolvedDate': !exists(json, 'resolved_date') ? undefined : (json['resolved_date'] === null ? null : new Date(json['resolved_date'])),
        'asset': json['asset'],
        'root': !exists(json, 'root') ? undefined : json['root'],
        'parent': !exists(json, 'parent') ? undefined : json['parent'],
    };
}

export function CommentUpdateToJSON(value?: CommentUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assignee': ElementsUserMiniReferenceToJSON(value.assignee),
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'drawing': value.drawing,
        'tags': value.tags === undefined ? undefined : ((value.tags as Array<any>).map(TagReferenceToJSON)),
        'text': value.text,
        'time': value.time,
        'is_cloud': value.isCloud,
        'resolved': value.resolved,
        'resolved_date': value.resolvedDate === undefined ? undefined : (value.resolvedDate === null ? null : value.resolvedDate.toISOString()),
        'asset': value.asset,
        'root': value.root,
        'parent': value.parent,
    };
}


